module.exports = __webpack_public_path__ + "img/img-5.8abc0a08.jpg";